const PARTNER_DPC_OVERVIEW_LIST = "v3/partner/:partnerId/dpcOverview";

const PARTNER_CAMPAIGNS_FOR_ANALYTICS =
  "v3/campaign/:partnerId/fetchCampaignsforAnalytics";

const PARTNER_CAMPAIGN_PRODUCTS = "v3/campaign/:partnerId/getproducts";
const PARTNER_CAMPAIGN_BRANDS = "v3/campaign/:partnerId/getbrands";
const PARTNER_COUNTRIES = "v3/campaign/:partnerId/getcountries";
const PARTNER_FILTER_ANALYTICS = "v3/campaign/filterAnalytics";

const GET_SERVICE_STATUSSES =
  "v3/service/partner/:serviceId/retrieveServiceChoice";

const GET_PARTNER_TEMPLATES = "v3/partner/:partnerId/templates";
const UPDATE_PARTNER_TEMPLATES = "v3/partner/:partnerId/templates/update";

const GET_CONTACT_SETTINGS = "v3/partner/:partnerId/contact-settings";
const SAVE_CONTACT_SETTINGS = "v3/partner/:partnerId/contact-settings/save";

export {
  PARTNER_DPC_OVERVIEW_LIST,
  PARTNER_CAMPAIGNS_FOR_ANALYTICS,
  PARTNER_CAMPAIGN_PRODUCTS,
  PARTNER_CAMPAIGN_BRANDS,
  PARTNER_COUNTRIES,
  PARTNER_FILTER_ANALYTICS,
  GET_SERVICE_STATUSSES,
  GET_PARTNER_TEMPLATES,
  UPDATE_PARTNER_TEMPLATES,
  GET_CONTACT_SETTINGS,
  SAVE_CONTACT_SETTINGS,
};
